/**
 * @generated SignedSource<<ddb6f099eadf5b91de61955c868a3d38>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ChatThreadPurposeEnum = "applicant_feedback" | "hiring";
import { FragmentRefs } from "relay-runtime";
export type ChatThreadMessages_Thread$data = {
  readonly id: string;
  readonly messagesNotFromSelf: {
    readonly totalCount: number | null | undefined;
  } | null | undefined;
  readonly purpose: ChatThreadPurposeEnum | null | undefined;
  readonly recipient: {
    readonly " $fragmentSpreads": FragmentRefs<"ChatThreadMessages_Recipient">;
  } | null | undefined;
  readonly unreadMessages: {
    readonly totalCount: number | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"ChatThreadMessages_Messages">;
  readonly " $fragmentType": "ChatThreadMessages_Thread";
};
export type ChatThreadMessages_Thread$key = {
  readonly " $data"?: ChatThreadMessages_Thread$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChatThreadMessages_Thread">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalCount",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": 5,
      "kind": "LocalArgument",
      "name": "initialMessageCount"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChatThreadMessages_Thread",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "purpose",
      "storageKey": null
    },
    {
      "alias": "messagesNotFromSelf",
      "args": [
        {
          "kind": "Literal",
          "name": "filters",
          "value": {
            "excludeSelf": true
          }
        }
      ],
      "concreteType": "ChatMessageConnection",
      "kind": "LinkedField",
      "name": "chatMessages",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": "chatMessages(filters:{\"excludeSelf\":true})"
    },
    {
      "alias": "unreadMessages",
      "args": [
        {
          "kind": "Literal",
          "name": "filters",
          "value": {
            "unread": true
          }
        }
      ],
      "concreteType": "ChatMessageConnection",
      "kind": "LinkedField",
      "name": "chatMessages",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": "chatMessages(filters:{\"unread\":true})"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "recipient",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ChatThreadMessages_Recipient"
        }
      ],
      "storageKey": null
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "count",
          "variableName": "initialMessageCount"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ChatThreadMessages_Messages"
    }
  ],
  "type": "ChatThread",
  "abstractKey": null
};
})();

(node as any).hash = "9f767e48f7b26e65101a3d1eb6f25ffb";

export default node;
